import { createSlice } from '@reduxjs/toolkit';

const filterInitialState = "";

const filterSlice = createSlice({
  name: 'filter',
  initialState: filterInitialState,
  reducers: {
    filterContact(_, action) {
      return action.payload;
    },
  },
});


export const { filterContact } = filterSlice.actions;

export const filterReducer = filterSlice.reducer;